function displayList(selection) {
    const selectedCategory = selection.getAttribute("id");
    const selectionList = document.getElementsByClassName(selectedCategory)[0];
    selectionList.style.display = "flex"; 
}

function renderDefaultProduct() {
    const defaultSelection = document.querySelector(".mega-menu__list-inner-children .grand-menu");
    defaultSelection.style.display = "flex";
    document.querySelector(".mega-menu__inner-item").classList.add("item_underline");
}

// Render default list if no previous pre selection or not on a product page
const productMenu = document.querySelector('#HeaderMenu-1');
productMenu.addEventListener("click", (e) => {
    const getActiveProduct = document.querySelector(".mega-menu__link--active");
    const selectionExists = document.querySelector(".item_underline");
    
    if (selectionExists == null && getActiveProduct == null) {
        renderDefaultProduct();
    } else if (getActiveProduct && selectionExists == null) {
        const activeProductClassSlug = getActiveProduct.closest("ul").getAttribute("data-handle");
        const productClassSlugCategory = document.querySelector(`#${activeProductClassSlug}`);
        if (productClassSlugCategory == null) {
            renderDefaultProduct();
        } else {
            productClassSlugCategory.classList.add("item_underline");
            getActiveProduct.closest("ul").style.display = "flex";
        }
    } else {
        displayList(selectionExists);
    }
})

// add/remove underline and render inner list
const items = document.getElementsByClassName("mega-menu__list-child-item");
for (let i = 0; i < items.length; i++) {
  items[i].addEventListener("click", (e) => {
      const list = document.querySelectorAll(".grand-menu");
      for (let i = 0; i < list.length; ++i) {
          list[i].style.display = "none";
      }
      displayList(e.target);

      const catList = document.querySelectorAll(".mega-menu__list-child-item .mega-menu__inner-item");
      for (let i = 0; i < catList.length; ++i) {
          catList[i].classList.remove("item_underline");
      }
      e.target.classList.add("item_underline");
  });
}
